import React from 'react'
import PropTypes from 'prop-types'
import SwitchButton from '../../FormComponents/SwitchButton/Switch'
import { page as pageIndex } from '../../../globals'

class CustomAlerts extends React.PureComponent {
  returnSubjectRows = () => {
    const { trackData, updateData } = this.props
    return subjects.map((item, i) => {
      const className = trackData.customAlerts.radio[item.id]
        ? 'alert-row-record custom-row'
        : 'alert-row-record custom-row grey-alert-rows'
      if (!trackData.customAlerts.radio[item.id]) {
        trackData.customAlerts.radio[item.id] = false
      }
      return <div key={i} className={className}>
        <div className="alerts-col allow-click">
          <SwitchButton
            text="Subscribed"
            location={{ page: pageIndex.dashboard, field: 'customAlerts' }}
            id={item.id}
            isEnabled={trackData.customAlerts.radio[item.id]}
            updateData={updateData}
          />
        </div>
        <div className="alerts-col">{item.type}</div>
        <div className="alerts-col">{item.listName}</div>
      </div>
    })
  }

  render () {
    return <div className="alert-category-body custom-scroll">
      <div className="category-alerts-title">Custom Alerts</div>
      <div className="category-alerts-subtitle">
        Setup or modify e-mail alerts based on personal lists created in Legis Track or Regs Track.
      </div>
      <div className="rows-wrapper">
        <div className="alert-title-wrapper custom-title">
          {titles.map((item, i) => {
            return <div key={i} className="alerts-col title">{item}</div>
          })}
        </div>
        {this.returnSubjectRows()}
      </div>
    </div>
  }

  static propTypes = {
    trackData: PropTypes.object,
    updateData: PropTypes.func
  }
}

export default CustomAlerts

const titles = ['Subscribe', 'Type', 'List Name']
const subjects = [
  {
    type: 'Legis Track',
    listName: 'LIst name 1',
    id: 'sub1'
  },
  {
    type: 'Regs Track',
    listName: 'LIst name 2',
    id: 'sub2'
  },
  {
    type: 'Regs Track',
    listName: 'LIst name 3',
    id: 'sub3'
  },
  {
    type: 'Regs Track',
    listName: 'LIst name 4',
    id: 'sub4'
  }
]



// WEBPACK FOOTER //
// ./src/components/ManagementEmailAlerts/components/CustomAlerts.js